import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    historyMenuItem: {
    color: theme.palette.grey.grey500,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '140%',
    "&.Mui-selected": {
      color: theme.palette.primary.primary800,
      fontWeight: 500
    }
  },
  historyListSubHeader: {
    color: theme.palette.grey.grey400,
    fontSize: '10px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '120%', 
    textTransform: 'uppercase'
  },
  graphEvolutionDialog: {
    backgroundColor: theme.palette.grey.grey100,
    padding: '20px 40px',
  },
  graphEvolutionContent: {
    backgroundColor: theme.palette.grey.grey100,
    minWidth: '685px',
    minHeight: '348px',
    display: 'flex',
    justifyContent: 'center',
    padding: '20px 0',
  },
  historyBtnTooltipTitle: {
    display: 'flex',
  },

}));

export default useStyles;